import * as React from "react"
import Layout from "../components/layout"
import Footer from "../components/footer"
import "../styles.scss"
import LoadingSpinner from "../components/LoadingSpinner"
import { parse } from "node-html-parser"
import InfiniteScroll from "react-infinite-scroller"
import fetch from "node-fetch"
import Tooltip from "./Tooltip"
import Selector from "./Selector"

const affiliate =
  "utm_source=travellead&utm_medium=cps&utm_campaign=1174-baliceparking.pl&a_aid=1174&chan=planujemy&data1=planujemywakacje&a_cid=11111111"

const sortingFiltersEnum = Object.freeze({
  Najpopularniejsze: "",
  "Cena rosnąco": "tanio",
  "Najwyższy rabat": "przecena",
  "Najwyżej oceniane": "ocena-malejaco",
})

const getDepartureIcon = type => {
  switch (type) {
    case "własny":
      return "🚗"
    case "autokar":
      return "🚍"
    case "samolot":
      return "🛫"
    default:
      return "🚗"
  }
}

const getDeparture = (places, type) => {
  if (places.length > 0) {
    return places.join(", ")
  } else if (type === "własny") {
    return "Dojazd własny"
  }
  return type
}

const handleClickOffer = offer => {
  if (window && window.gtag && typeof window.gtag === "function") {
    // eslint-disable-next-line no-undef
    window.gtag("event", "click-offer", {
      event_category: "click-offer",
      event_label: offer.name,
    })
  }
  if (window?.fbq && typeof window.fbq === "function") {
    // eslint-disable-next-line no-undef
    window.fbq("track", "Purchase", {
      content_ids: offer.id,
      value: offer.price,
      currency: "PLN",
      content_type: "product",
      content_name: offer.name,
    })
  }
}

const SearchForm = ({
  children,
  dataDirections,
  initialUrl,
  topContent = null,
}) => {
  const [url, setUrl] = React.useState(
    initialUrl ?? "https://www.wakacje.pl/wczasy/?"
  )
  const [offers, setOffers] = React.useState([])
  const [offersAmount, setOffersAmount] = React.useState("")
  const [warningtext, setWarningtext] = React.useState("")
  const [currentPage, setCurrentPage] = React.useState(1)
  const [isLoading, setIsLoading] = React.useState(false)
  const [filters, setFilters] = React.useState({
    sorting: sortingFiltersEnum.Najpopularniejsze,
  })

  const urlRef = React.useRef(url)
  urlRef.current = url
  const ref = React.useRef(null)

  const getData = async () => {
    if (isLoading) return
    setIsLoading(true)
    if (currentPage === 1) {
      setOffers([])
      setOffersAmount(0)
    }

    setWarningtext("")

    const url = urlRef?.current
    const daysSuffix = ",1-28-dni"
    const shouldAddDaysSuffix = warningtext && currentPage > 1
    let parsedUrl = url.replace("&", "")
    if (filters.sorting !== sortingFiltersEnum.Najpopularniejsze) {
      const shouldAddComma =
        parsedUrl.slice(-1) !== "&" && parsedUrl.slice(-1) !== "?"
      parsedUrl += `${shouldAddComma ? "," : ""}${filters.sorting}`
    }
    const shouldAddComma =
      parsedUrl.slice(-1) !== "&" && parsedUrl.slice(-1) !== "?"
    const formattedUrl =
      "https://justcors.com/l_469mqcqx9m/" +
      parsedUrl +
      `${shouldAddComma ? "," : ""}str-${currentPage}${
        shouldAddDaysSuffix ? daysSuffix : ""
      }`
    // const formattedUrl = parsedUrl + `${shouldAddComma ? ',' : ''}str-${currentPage}${shouldAddDaysSuffix ? daysSuffix : ''}`;

    const html = await fetch(formattedUrl, {
      // mode: "cors",
      method: "GET",
      // headers: {
      //   "Access-Control-Allow-Origin": "*",
      //   // 'Access-Control-Allow-Credentials': 'true',
      //   // 'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
      //   // 'Access-Control-Allow-Headers': '*',
      //   // 'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,PUT,DELETE,PATCH',
      //   'Content-Type': 'text/html',
      //   'Accept-Encoding': 'gzip, deflate, br',
      //   'Cache-Control': 'no-cache',

      //   'x-requested-with': '*'
      // },
    }).then(res => res.text())

    const root = parse(html)

    const parsedWarningText =
      root
        .querySelector('[data-area="searchMessage"]')
        ?.innerText?.replace(/\n|\r/g, " ") || ""

    try {
      const { itemListElement } = JSON.parse(
        root.querySelectorAll('script[type="application/ld+json"]')[1].innerHTML
      )
      const { data, count } = JSON.parse(
        root.querySelector("script#__NEXT_DATA__ ")?.innerText
      )?.props.stores.storeOffers.offers
      const mappedOffers = data.map(offer => {
        return {
          id: offer.id,
          offerIdd: offer.offerId,
          name: offer.name,
          price: offer.price,
          stars: offer.category,
          src: Object.values(offer.photos)[0][0],
          breadcrumb: offer.placeName,
          journeyDate: `${new Date(
            offer.departureDate
          ).toLocaleDateString()} - ${new Date(
            offer.returnDate
          ).toLocaleDateString()}`,
          daysAmount: offer.duration,
          departurePlaces: offer.departurePlaces,
          departureTypeName: offer.departureTypeName,
          food: offer.serviceDesc,
          travelAgent: offer.tourOperatorName,
          link: `${
            itemListElement.find(({ url }) => url.includes(offer.id))?.url
          }?od-${offer.departureDate},${offer.duration}-dni&${affiliate}`,
          priceBeforeDiscount: offer.priceOld,
          discount: offer.priceDiscount, // 27
          opinionsText: offer.ratingLabel,
          opinionsAmount: offer.ratingRecommends,
          opinionsMark: offer.ratingValue,
          isLastMinute: offer.promoLastMinute,
          isFirstMinute: offer.promoFirstMinute,
        }
      })

      setOffers([...offers, ...mappedOffers])

      setOffersAmount(count)
      setWarningtext(parsedWarningText)
      setCurrentPage(currentPage + 1)
      setIsLoading(false)

      if (window && window.gtag && typeof window.gtag === "function") {
        // eslint-disable-next-line no-undef
        window.gtag("event", "search-offer", {
          event_category: "seach-offers",
          event_label: `page: ${currentPage}`,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const updateUrlFromButtonUrl = (timer = 0) => {
    const newUrl = ref?.current?.querySelector(
      "[data-widget=search] > span > div > div > div> a"
    )

    if (newUrl?.href && newUrl?.href !== url) {
      setUrl(
        newUrl?.href?.replace(
          "utm_source=travellead&utm_medium=cps&utm_campaign=1174-baliceparking.pl&utm_content=widget-search&a_aid=1174",
          ""
        )
      )
    }
  }

  const handleClickSearch = async () => {
    if (window && window.gtag && typeof window.gtag === "function") {
      // eslint-disable-next-line no-undef
      window.gtag("event", "search", {
        event_category: "search",
        event_label:
          document.querySelector(
            "span > div > div > div> div > div > div > input"
          )?.value || "",
      })
    }

    setFilters({
      sorting: sortingFiltersEnum.Najpopularniejsze,
    })
    setCurrentPage(1)
    getData()
  }

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const script = document.createElement("script")
      script.src =
        "https://widget.wakacje.pl/v2/public/js/widgets/search-widget-v2.js?c=search-widget14"
      script.defer = true
      document.body.appendChild(script)
    }
  }, [])

  React.useEffect(() => {
    const updateUrlInterval = setInterval(() => {
      const newUrl =
        ref?.current?.querySelector(
          "[data-widget=search] > span > div > div > div> a"
        ) || ""

      if (newUrl?.href && newUrl?.href !== url) {
        updateUrlFromButtonUrl()
      }
    }, 500)

    return () => {
      updateUrlInterval && clearInterval(updateUrlInterval)
    }
    // eslint-disable-next-line
  }, [url])

  React.useEffect(() => {
    setTimeout(() => {
      updateUrlFromButtonUrl()
      const searchBtn = ref?.current?.querySelector(
        "[data-widget=search] > span > div > div > div > a"
      )
      searchBtn.setAttribute("style", "display: none!important")
      const btn = document.createElement("button")
      searchBtn.parentElement.appendChild(btn)

      btn.innerHTML = "<span>Wyszukaj</span>"
      btn.id = "search-offer-btn"
      btn.classList = searchBtn.classList
      btn.addEventListener("click", handleClickSearch)
    }, 1500)

    return () => {
      const btn = document.querySelector("#search-offer-btn")
      btn?.removeEventListener("click", handleClickSearch)
    }
    // eslint-disable-next-line
  }, [])

  const handleChangeSorting = e => {
    setCurrentPage(1)
    setFilters({
      sorting: e.target.value,
    })
    setOffersAmount(0)
    setOffers([])
  }

  return (
    <Layout>
      {topContent}
      <div
        id="search-widget14"
        data-widget="search"
        data-branding="false"
        data-affiliate="1174"
        data-campaign="1174-baliceparking.pl"
        data-directions={dataDirections}
        ref={ref}
      >
        <div className="cover-layer"></div>
      </div>
      <div className="warningText">{warningtext}</div>
      {offersAmount ? (
        <div className="offersMainHeader">
          <div className="offersAmount">Znaleziono {offersAmount} ofert</div>
          <Selector
            options={Object.entries(sortingFiltersEnum)}
            selectedOption={filters.sorting}
            handleOnChange={handleChangeSorting}
          />
        </div>
      ) : null}
      <div
        id="allOffers"
        className={`allOfferContainer ${
          isLoading ? "allOfferContainerOverlay" : ""
        }`}
      >
        {isLoading && offers?.length === 0 ? (
          <LoadingSpinner hasRows={offers?.length} />
        ) : null}
        <InfiniteScroll
          dataLength={offersAmount}
          loadMore={getData}
          hasMore={offersAmount >= offers.length}
          loader={<div className="search-offer-loader">Szukam ofert...</div>}
        >
          {offers.map((offer, offerIdx) => {
            const pre = offer.src.slice("", offer.src.lastIndexOf("-"))
            const srcNoDimensions = pre.slice(pre, pre.lastIndexOf("-"))

            const hasOpinionsField =
              offer.opinionsMark && offer.opinionsText && offer.opinionsAmount
            return (
              <a
                key={offer.id}
                className="offer-container"
                href={offer.link}
                target="_blank"
                rel="noreferrer sponsored"
                onClick={() => handleClickOffer(offer)}
              >
                <div className="offerImageContainer">
                  {offer.isLastMinute ? (
                    <div className="lastMinuteTag">LAST MINUTE</div>
                  ) : null}
                  {!offer.isLastMinute && offer.isFirstMinute ? (
                    <div className="lastMinuteTag">FIRST MINUTE</div>
                  ) : null}
                  {hasOpinionsField ? (
                    <div className="mark markTag">
                      <div className="squareOpinions">
                        {offer.opinionsMark === 10
                          ? 10
                          : `${offer.opinionsMark}`.includes(".")
                          ? offer.opinionsMark
                          : `${offer.opinionsMark}.0`}
                      </div>
                      <div className="squareOpinionsDescription">
                        <span>{offer.opinionsText}</span>
                        <span>{offer.opinionsAmount} opinii</span>
                      </div>
                    </div>
                  ) : null}
                  <picture key={`${srcNoDimensions}-295-267.jpg`}>
                    <source
                      srcSet={`${srcNoDimensions}-340-180.jpg`}
                      media="(max-width: 400px)"
                    />
                    <source
                      srcSet={`${srcNoDimensions}-540-270.jpg`}
                      media="(max-width: 640px)"
                    />
                    <source
                      srcSet={`${srcNoDimensions}-295-267.jpg`}
                      media="(min-width: 640px)"
                    />
                    <img
                      width="295"
                      height="280"
                      loading="lazy"
                      className="offerImage"
                      src={`${srcNoDimensions}-295-267.jpg`}
                      alt="zdjęcie oferty wakacyjnej"
                    />
                  </picture>
                </div>
                <div className="offerDescriptionMainContainer">
                  <div className="offerDescriptionContainer">
                    <span className="breadcrumb">{offer.breadcrumb}</span>
                    <span className="name">{offer.name}</span>
                    <span className="stars">
                      {[...Array(parseInt(5)).keys()].map((_, idx) => (
                        <span className={idx < offer.stars ? "gold" : "silver"}>
                          ★
                        </span>
                      ))}
                    </span>
                    <span className="journeyDate">
                      <span className="icon">🗓</span>
                      {offer.journeyDate}
                    </span>
                    <span className="daysAmount">
                      <span className="icon">⌛️</span>
                      {offer.daysAmount} dni
                    </span>
                    <span className="departurePlaces">
                      <span className="icon">
                        {" "}
                        {getDepartureIcon(offer.departureTypeName)}{" "}
                      </span>
                      {getDeparture(
                        offer.departurePlaces,
                        offer.departureTypeName
                      )}
                    </span>
                    <span className="food">
                      <span className="icon">🍴</span>
                      {offer.food}
                    </span>
                    <span className="travelAgent">
                      <span className="icon">🏢</span>
                      {offer.travelAgent}
                    </span>
                    <span className="provider">
                      <span className="icon"></span>
                      od: {"wakacje.pl"}
                    </span>
                  </div>
                </div>
                <div className="offer-summary-container">
                  <div className={`offer-summary`}>
                    {/* {hasOpinionsField ? <div className="mark">
                      <div className="squareOpinions">{`${offer.opinionsMark}`.includes('.') ? offer.opinionsMark : `${offer.opinionsMark}.0`}</div>
                      <div className="squareOpinionsDescription">
                        <span>{offer.opinionsText}</span>
                        <span>{offer.opinionsAmount} opinii</span>
                      </div>
                    </div> : null} */}
                    <div className="price">
                      {/* eslint-disable-next-line */}
                      {offer.discount && offer.discount != 0 ? (
                        <div className="priceBeforeDiscountContainer">
                          <div className="priceBeforeDiscountPercent">
                            {`${offer.discount}`.includes("-")
                              ? offer.discount
                              : `-${offer.discount}`}
                            %
                          </div>
                          <div className="priceBeforeDiscount">
                            {offer.priceBeforeDiscount} zł
                          </div>
                        </div>
                      ) : null}
                      {offer.price} zł{" "}
                      <span className="pricePerPerson">za wszystkich</span>
                    </div>
                    <div>
                      <button
                        href={offer.link}
                        className="offerActionBtn"
                        target="_blank"
                        rel="noreferrer sponsored"
                        onClick={() => handleClickOffer(offer)}
                      >
                        Zobacz ofertę ▶
                      </button>
                      <span
                        role="button"
                        href={offer.link}
                        aria-hidden="true"
                        className="offerAction"
                        target="_blank"
                        rel="noreferrer sponsored"
                        onClick={() => handleClickOffer(offer)}
                      >
                        Inne ceny i terminy ▶
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            )
          })}
        </InfiniteScroll>
      </div>

      {isLoading && offers?.length ? (
        <LoadingSpinner
          hasRows={offers?.length}
          text={"Szukam więcej ofert ..."}
        />
      ) : null}
      <Tooltip
        withMargin
        content="Stanowią własność prawnie chronioną należącą do Wakacje.pl S.A. i/lub jej partnerów”"
        direction="right"
      >
        <span className="wakacje-warning">
          Niektóre treści pochodzą z serwisu wakacje.pl. ℹ
        </span>
      </Tooltip>
      {children}

      <Footer />
    </Layout>
  )
}

export default SearchForm
